/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationRelationUnlinkChild } from '../../axios/organisationRelationUnlinkChild'
import type {
	OrganisationRelationUnlinkChildError,
	OrganisationRelationUnlinkChildPathParams,
	OrganisationRelationUnlinkChildResponse,
} from '../../types/OrganisationRelationUnlinkChild'

export const organisationRelationUnlinkChildMutationKey = () =>
	[{ url: '/organisations/:organisation/children/:child' }] as const

export type OrganisationRelationUnlinkChildMutationKey = ReturnType<typeof organisationRelationUnlinkChildMutationKey>

export type OrganisationRelationUnlinkChildVariables = {
	organisation: OrganisationRelationUnlinkChildPathParams['organisation']
	child: OrganisationRelationUnlinkChildPathParams['child']
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationRelationController.php OrganisationRelationController::unlinkChild */
export function useOrganisationRelationUnlinkChild<TContext = unknown>(
	options?: UseMutationOptions<
		OrganisationRelationUnlinkChildResponse,
		AxiosError<OrganisationRelationUnlinkChildError>,
		OrganisationRelationUnlinkChildVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: organisationRelationUnlinkChildMutationKey(),
		mutationFn: ({ organisation, child }: OrganisationRelationUnlinkChildVariables) =>
			organisationRelationUnlinkChild(organisation, child, config).then(res => res.data),
		...options,
	})
}
